import {
  cacheByQueryArgProperties,
  defaultTags,
  invalidatesUnauthorized,
  invalidatesUnknownErrors,
  providesListTags,
  cacheByQueryArg
} from './genericCacheUtils';
import { cacheByPaginationQueryArgs } from './paginationCacheUtils';

export const cacher = {
  defaultTags,
  cacheByQueryArgProperties,
  providesListTags,
  cacheByPaginationQueryArgs,
  invalidatesUnauthorized,
  invalidatesUnknownErrors,
  cacheByQueryArg
};
